<template>
  <div>
    <Menu
      :orderTypeSelected="orderTypeSelected"
      :fee="feeOrder"
      :deliveryPaymentType="establishmentDeliveryPaymentType"
    />
  </div>
</template>
<script>
import Menu from "@/components/Xpress/orders/Menu";
export default {
  name: "XpressMenu",
  components: {
    Menu,
  },
  computed: {
    orderTypeSelected() {
      return this.$route.params.orderType;
    },
    feeOrder() {
      return this.$route.params.fee;
    },
    establishmentDeliveryPaymentType() {
      return this.$store.getters.getEstablishmentDeliveryPaymentType;
    },
  },
};
</script>
